import request from './request'

export const adminApi = {
  // 管理员登录
  login: (data) => {
    return request({
      url: '/admin/auth/login',
      method: 'post',
      data
    })
  },

  // 管理员登出
  logout: () => {
    return request({
      url: '/admin/auth/logout',
      method: 'post'
    })
  },

  // 验证Token
  verifyToken: () => {
    return request({
      url: '/admin/auth/verify',
      method: 'get'
    })
  },

  // 获取管理员信息
  getAdminInfo: () => {
    return request({
      url: '/admin/info',
      method: 'get'
    })
  },

  // 更新管理员信息
  updateAdminInfo: (data) => {
    return request({
      url: '/admin/info',
      method: 'put',
      data
    })
  },

  // 修改密码
  changePassword: (data) => {
    return request({
      url: '/admin/password',
      method: 'put',
      data
    })
  }
}

export const userApi = {
  // 获取用户列表
  getUserList: (params) => {
    return request({
      url: '/admin/users',
      method: 'get',
      params
    })
  },

  // 获取用户详情
  getUserDetail: (id) => {
    return request({
      url: `/admin/users/${id}`,
      method: 'get'
    })
  },

  // 更新用户状态
  updateUserStatus: (id, data) => {
    return request({
      url: `/admin/users/${id}/status`,
      method: 'put',
      data
    })
  },

  // 删除用户
  deleteUser: (id) => {
    return request({
      url: `/admin/users/${id}`,
      method: 'delete'
    })
  },

  // 新增：批量通知用户
  notifyUsers: (data) => {
    return request({
      url: '/admin/users/notify',
      method: 'post',
      data
    })
  },

  // 新增：重置用户密码
  resetPassword: (id, newPassword) => request({ url: `/admin/users/${id}/reset-password`, method: 'post', data: { newPassword } }),

  // 新增：重置用户管理密码为 123456
  resetManagementPassword: (id) => request({ url: `/admin/users/${id}/reset-management-password`, method: 'post' }),

  // 新增：为用户设置会员类型与到期时间
  setMembership: (id, data) => request({ url: `/admin/users/${id}/membership`, method: 'post', data }),
}

export const statisticsApi = {
  // 获取仪表盘数据
  getDashboardData: (params = {}) => {
    return request({
      url: '/admin/dashboard',
      method: 'get',
      params
    })
  },

  // 获取用户统计
  getUserStatistics: (params) => {
    return request({
      url: '/admin/statistics/users',
      method: 'get',
      params
    })
  },

  // 获取使用统计
  getUsageStatistics: (params) => {
    return request({
      url: '/admin/statistics/usage',
      method: 'get',
      params
    })
  },

  // 获取地域分布
  getRegionStatistics: (params) => {
    return request({
      url: '/admin/statistics/regions',
      method: 'get',
      params
    })
  }
}

export const aiApi = {
  // AI 助理总体统计（按模型/趋势/Top用户）
  getSummary: (params) =>
    request({
      url: '/admin/ai/summary',
      method: 'get',
      params
    }),

  // AI 助理按用户列表（含按模型简表）
  getUsers: (params) =>
    request({
      url: '/admin/ai/users',
      method: 'get',
      params
    }),

  // AI 助理单用户明细（按模型/趋势）
  getUserDetail: (id, params) =>
    request({
      url: `/admin/ai/users/${id}`,
      method: 'get',
      params
    })
}

export const membershipApi = {
  // 获取会员列表
  getMembershipList: (params) => {
    return request({
      url: '/admin/memberships',
      method: 'get',
      params
    })
  },

  // 更新会员状态
  updateMembershipStatus: (id, data) => {
    return request({
      url: `/admin/memberships/${id}`,
      method: 'put',
      data
    })
  },

  // 获取会员统计
  getMembershipStatistics: () => {
    return request({
      url: '/admin/memberships/statistics',
      method: 'get'
    })
  },

  // 导出会员（按当前筛选）
  exportMemberships: (params) => {
    return request({
      url: '/admin/memberships/export',
      method: 'get',
      params,
      responseType: 'blob'
    })
  },

  // 新增：开通/延期/升级
  openMembership: (data) => request({ url: '/admin/memberships/open', method: 'post', data }),
  extendMembership: (data) => request({ url: '/admin/memberships/extend', method: 'post', data }),
  upgradeMembership: (data) => request({ url: '/admin/memberships/upgrade', method: 'post', data }),
}

export const logsApi = {
  // 获取操作日志
  getOperationLogs: (params) => {
    return request({
      url: '/admin/logs/operations',
      method: 'get',
      params
    })
  },

  // 获取系统日志
  getSystemLogs: (params) => {
    return request({
      url: '/admin/logs/system',
      method: 'get',
      params
    })
  },

  // 清理日志
  clearLogs: (data) => {
    return request({
      url: '/admin/logs/clear',
      method: 'post',
      data
    })
  },

  // 导出操作日志（按当前筛选）
  exportOperationLogs: (params) => {
    return request({
      url: '/admin/logs/operations/export',
      method: 'get',
      params,
      responseType: 'blob'
    })
  }
}

export const settingsApi = {
  // 获取系统设置
  getSystemSettings: () => {
    return request({
      url: '/admin/settings',
      method: 'get'
    })
  },

  // 更新系统设置
  updateSystemSettings: (data) => {
    return request({
      url: '/admin/settings',
      method: 'put',
      data
    })
  },

  // 获取系统状态
  getSystemStatus: () => {
    return request({
      url: '/admin/system/status',
      method: 'get'
    })
  },

  // 新增：各子配置保存
  saveEmailSettings: (data) => request({ url: '/admin/settings/email', method: 'post', data }),
  saveSmsSettings: (data) => request({ url: '/admin/settings/sms', method: 'post', data }),
  saveSecuritySettings: (data) => request({ url: '/admin/settings/security', method: 'post', data }),
  saveRateLimitSettings: (data) => request({ url: '/admin/settings/ratelimit', method: 'post', data }),
}

export const auditApi = {
  // 上报操作日志
  reportOperation: (data) => {
    return request({
      url: '/admin/logs/operations',
      method: 'post',
      data,
    })
  },
}

export const notificationsApi = {
  getList: (params) => request({ url: '/admin/notifications', method: 'get', params }),
  create: (data) => request({ url: '/admin/notifications', method: 'post', data }),
  update: (id, data) => request({ url: `/admin/notifications/${id}`, method: 'put', data }),
  remove: (id) => request({ url: `/admin/notifications/${id}`, method: 'delete' }),
  publish: (id, data) => request({ url: `/admin/notifications/${id}/publish`, method: 'post', data }),
} 
